import React from "react";
import Sidebar from "../../../../components/AdminComponents/SideNav";
import {
  SecondaryNavTNCommunications,
  SettingsMenu,
} from "../../../../components/AdminComponents/MenuItems";
import SideTableNotifications from "./SideTableNotifications";
import SecondaryNav from "../../../../components/AdminComponents/SecondaryNav2";

const TnViewNotifications = () => {
  return (
    <Sidebar props={SettingsMenu}>
      <SecondaryNav menuItems={SecondaryNavTNCommunications} />
      <SideTableNotifications from="TN_ADMIN" />
    </Sidebar>
  );
};

export default TnViewNotifications;
